export const bscPools = [
  {
    id: 'Tianguis-MORRALLA-BNB',
    name: 'MORRALLA-BNB LP',
    token: 'MORRALLA-BNB LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0x7D30522145e302841387049B7ba857BD8ad30548',
    tokenDecimals: 18,
    tokenDescriptionUrl: 'https_',
    earnedToken: 'tianguisMorrallaBnb',
    earnedTokenAddress: '0x64dfaccD87a4E033a75BE5c4E5199fafd6851146',
    earnContractAddress: '0x64dfaccD87a4E033a75BE5c4E5199fafd6851146',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-bnb',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'BNB'],
    addLiquidityUrl: 'https://tianguis.finance/add/0xadcBAEbaac0f775923eBDFb6B904399DA8801275/BNB',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0xadcBAEbaac0f775923eBDFb6B904399DA8801275',
  },
    // pcs router abajo todo 0s
  /*  {
    id: 'tianguis-morralla-bnb',
    name: 'MORRALLA-BNB LP',
    token: 'MORRALLA-BNB LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0xe54B765983fC0A2E15943a5d9fc8b1AF7bbc9aA6',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'tianguisMorrallaBnb',
    earnedTokenAddress: '0xdC1480ec5572624D9cfAa0280FdB65dca2EE157C',
    earnContractAddress: '0xdC1480ec5572624D9cfAa0280FdB65dca2EE157C',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-bnb',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'BNB'],
    addLiquidityUrl: 'https://tianguis.finance/add/0xadcBAEbaac0f775923eBDFb6B904399DA8801275/BNB',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0xadcBAEbaac0f775923eBDFb6B904399DA8801275',
  }, */
  {
    id: 'tianguis-morralla-busd',
    name: 'MORRALLA-BUSD LP',
    token: 'MORRALLA-BUSD LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0xa36c4c7d11732681e58cbb7b8716acb8871ec4c3',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'tianguisMorallaBusd',
    earnedTokenAddress: '0x78f2644B9Ba56A0BB931Be310fbBBbfbB607fCaF',
    earnContractAddress: '0x78f2644B9Ba56A0BB931Be310fbBBbfbB607fCaF',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-busd',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'BUSD'],
    addLiquidityUrl:
      'https://tianguis.finance/add/0xadcBAEbaac0f775923eBDFb6B904399DA8801275/0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0xeD24FC36d5Ee211Ea25A80239Fb8C4Cfd80f12Ee',
  },
  {
    id: 'tianguis-morralla-xrp',
    name: 'MORRALLA-XRP LP',
    token: 'MORRALLA-XRP LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0x3140efe2f611c8391e39e3179e50c59a74731371',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'tianguisMorallaXrp',
    earnedTokenAddress: '0x4d73793fef722a567942d51B5aaf057c42A73d22',
    earnContractAddress: '0x4d73793fef722a567942d51B5aaf057c42A73d22',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-xrp',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'XRP'],
    addLiquidityUrl:
      'https://tianguis.finance/add/0xadcBAEbaac0f775923eBDFb6B904399DA8801275/0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0x1D2F0da169ceB9fC7B3144628dB156f3F6c60dBE',
  },
  {
    id: 'tianguis-morralla-eth',
    name: 'MORRALLA-ETH LP',
    token: 'MORRALLA-ETH LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0xAA4C6f6d60F1E52eA9dF8dcE98860eF6E5FC1f36',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'TianguisMorallaEth',
    earnedTokenAddress: '0xE698F4947a0Bddc4f03D55A1A679fA502aA117D8',
    earnContractAddress: '0xE698F4947a0Bddc4f03D55A1A679fA502aA117D8',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-eth',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'ETH'],
    addLiquidityUrl: 'https://tianguis.finance/add/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/BNB',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9',
  },
  {
    id: 'tianguis-morralla-btc',
    name: 'MORRALLA-BTC LP',
    token: 'MORRALLA-BTC LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0xb1827e26d37a04b6b73851dc0a891ece8e414c42',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'TianguisMorallaBtc',
    earnedTokenAddress: '0x909BD0B28F03A1db58C3461502dBd9021cCfBdC7',
    earnContractAddress: '0x909BD0B28F03A1db58C3461502dBd9021cCfBdC7',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-btc',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'BTC'],
    addLiquidityUrl: 'https://tianguis.finance/add/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/BNB',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9',
  },
  {
    id: 'tianguis-morralla-ada',
    name: 'MORRALLA-ADA LP',
    token: 'MORRALLA-ADA LP',
    tokenDescription: 'Tianguis Finance',
    tokenAddress: '0xeb8967533572027a337961690adc3e5fb2f9fccc',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'TianguisMorallaAda',
    earnedTokenAddress: '0xC1b412A4da914a97da7d45C16451F6d7BfC253c2',
    earnContractAddress: '0xC1b412A4da914a97da7d45C16451F6d7BfC253c2',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'lps',
    oracleId: 'tianguis-morralla-ada',
    oraclePrice: 0,
    depositsPaused: true,
    status: 'eol',
    platform: 'Tianguis',
    assets: ['MORRALLA', 'ADA'],
    addLiquidityUrl: 'https://tianguis.finance/add/0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82/BNB',
    buyTokenUrl:
      'https://tianguis.finance/swap?outputCurrency=0x5B6DcF557E2aBE2323c48445E8CC948910d8c2c9',
  },
];
